// extracted by mini-css-extract-plugin
export default {"StudentSelects":"StudentSelects_StudentSelects__oY2GI","faculty":"StudentSelects_faculty__fqFF9","input":"StudentSelects_input__d0ud8"};